import React, { useEffect, useState } from 'react';
import { Grid, Box, Typography, Popover } from "@mui/material";
import { styles } from "./styles";
import { useLocation } from "react-router-dom";
import {dashRoutes, deviceRoutes, adminRoutes, truckRoutes, tagSchemeRoutes, reportRoutes} from "utils/routes";
import { useMsal } from "@azure/msal-react";

interface HeaderProps {
}

const Header: React.FC<HeaderProps> = () => {
  const location = useLocation();
  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null);
  let combined = [...dashRoutes, ...deviceRoutes, ...truckRoutes,...tagSchemeRoutes,...reportRoutes,...adminRoutes];
  let { header } = combined.filter(c => c.route === location.pathname)[0] || { header: "" };
  const { instance, accounts } = useMsal();
  const [username, setUsername] = useState("VS");

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  const handleLogout = (logoutType: string) => {
    if (logoutType === "popup") {
      instance.logoutPopup({
        postLogoutRedirectUri: "/",
        mainWindowRedirectUri: "/" // redirects the top level app after logout
      });
    }
  }

  useEffect(() => {
    if(accounts.length > 0) {
      if(accounts[0].name) {
        let newName = getInitials(accounts[0].name);
        setUsername(newName);
      }
    }
  }, [accounts]);

  const getInitials = (str: string) =>  {
    let words = str.split(' ');
    let firstInitial = words[0][0];
    if (words.length === 1) {
      return firstInitial;
    }
    let secondInitial = words[1][0];
    return firstInitial + secondInitial;
  }

  return (
    <Grid item xs={12} sx={styles.container}>
      <h3>{header || ""}</h3>
      <Box display={"flex"} alignItems={"center"} onClick={(e: any) => handleClick(e)}>
        <Box sx={styles.profile}>{username}</Box>
      </Box>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
      >
        {accounts && accounts[0] && accounts[0].username && <Typography sx={{ p: 2, cursor: "pointer" }}>{accounts[0].username}</Typography>}
        <Typography sx={{ p: 2, cursor: "pointer" }} onClick={() => handleLogout("popup")}>Sign Out</Typography>
      </Popover>
    </Grid>
  )
}

export default Header;
